import { Alert, Box, Button, Skeleton, Typography } from "@mui/material";
import { useParams } from "react-router";
import { useDirtTalkByDate } from "../hooks/useApiQueries.js";
import { SEO } from "../components/SEO.js";
import { DirtTalkCard } from "../components/DirtTalkCard.js";
import { useState } from "react";
import dayjs from "dayjs";

export function DirtTalkDay() {
  const { date = "" } = useParams();
  const { data, isLoading } = useDirtTalkByDate(date);
  const [shared, setShared] = useState(false);

  if (isLoading) return <Skeleton variant="rectangular" height={300} />;
  if (!data || data.items.length === 0) return <Alert severity="info">No Dirt Talk for {date}.</Alert>;

  const url = `https://corianpark.au/dirt-talk/${date}`;

  return (
    <>
      <SEO
        title={`Dirt Talk — ${date}`}
        description={data.items.map((i) => i.title).join(" • ")}
        canonical={url}
        type="article"
        article={{ publishedTime: dayjs(date).toISOString(), author: "Corian Park" }}
      />
      <Typography variant="h3" sx={{ fontSize: 36, mb: 3 }}>
        Dirt Talk — {dayjs(date).format("dddd, D MMMM YYYY")}
      </Typography>
      {data.items.map((i) => (
        <Box key={i.id} sx={{ mb: 4 }}>
          <DirtTalkCard
            variant={i.variant}
            date={date}
            title={i.title}
            body={i.body}
            imageUrl={i.imageUrl}
            itemId={i.id}
            showSaveButton
          />
        </Box>
      ))}
      <Button
        variant="outlined"
        onClick={() => {
          navigator.clipboard.writeText(url);
          setShared(true);
        }}
      >
        {shared ? "Copied!" : "Copy share link"}
      </Button>
    </>
  );
}
